import { useEffects, useSound } from '@/contexts';
import type { ControlsProps } from '@/types/game';
import { memo } from 'react';

const ControlsComponent = ({
  onMove,
  disabled = false,
  showVisualFeedback = true,
}: ControlsProps) => {
  const { triggerEffect } = useEffects();
  const { playMove } = useSound();

  const handleMove = (direction: 'up' | 'down' | 'left' | 'right') => {
    if (disabled) return;

    playMove();
    onMove(direction);

    if (showVisualFeedback) {
      // Create a directional glow effect
      const positions: Record<string, [number, number]> = {
        up: [50, 30],
        down: [50, 70],
        left: [30, 50],
        right: [70, 50],
      };

      triggerEffect({
        type: 'glow',
        position: positions[direction],
        duration: 200,
        color: '#4ecdc4',
      });

      // Add a subtle particle burst for better feedback
      triggerEffect({
        type: 'particle',
        position: positions[direction],
        duration: 300,
        intensity: 5,
        color: '#4ecdc4',
      });
    }
  };

  return (
    <div id="controls" className="controls !hidden pointer-events-none select-none">
      <div
        id="top"
        className="controls__arrow controls__arrow--top"
        onClick={() => handleMove('up')}
      ></div>
      <div
        id="left"
        className="controls__arrow controls__arrow--left"
        onClick={() => handleMove('left')}
      ></div>
      <div
        id="right"
        className="controls__arrow controls__arrow--right"
        onClick={() => handleMove('right')}
      ></div>
      <div
        id="bottom"
        className="controls__arrow controls__arrow--bottom"
        onClick={() => handleMove('down')}
      ></div>
    </div>
  );
};

// Memoize to prevent unnecessary re-renders
const Controls = memo(ControlsComponent);

export default Controls;
